import { render, staticRenderFns } from "./Toggle.vue?vue&type=template&id=2125d23e&"
import script from "./Toggle.vue?vue&type=script&lang=js&"
export * from "./Toggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Toggle.vue?vue&type=custom&index=0&blockType=div&class=spectrum-ToggleSwitch%20spectrum-ToggleSwitch--ab"
if (typeof block0 === 'function') block0(component)

export default component.exports